import { useEffect, useState } from "react";

import cong from "../firebase/firebase"; // Assuming the correct path to your configuration file
import { getDatabase, ref ,onValue,remove} from "firebase/database";


export const ContactRead = (props) => {
  const [data, setData] = useState([]);
  const deleteVal = (val) =>{
    const database = getDatabase(cong);
       const collectionRef = ref(database, "leads/"+val.d);
       remove(collectionRef);
  }

  useEffect(() => {

    // Reference to the specific collection in the database

    const database = getDatabase(cong);
    // Reference to the specific collection in the database
    const collectionRef = ref(database, "leads");

    // Function to fetch data from the database
    const fetchData = () => {
      // Listen for changes in the collection
      onValue(collectionRef, (snapshot) => {
        const dataItem = snapshot.val();

        // Check if dataItem exists
        debugger
        if (dataItem) {
          // Convert the object values into an array
          const displayItem = Object.values(dataItem);
          debugger
          setData(displayItem);
        }
      });
    };

    // Fetch data when the component mounts
    fetchData();
  }, []);
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Data Requests</h2>
                <table style={{color:"white"}}>
                  <th style={{padding:4}}>name</th>
                  <th style={{padding:4}}>email</th>
                  <th style={{padding:4}}>message</th>
                  <tbody >
                    {data && data.map((val,key)=><tr>
                        <td style={{padding:4}}>
                        {val.name}
                        </td >
                        <td style={{padding:4}}>
                        {val.email}
                        </td>
                        <td style={{padding:4}}>
                        {val.message}
                        </td>
                        <td style={{padding:4,cursor:"pointer"}} onClick={()=>deleteVal(val)}>
                       delete
                        </td>
                    </tr>)}
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
